<template>
  <div class="page-table musteriTanim  mainDiv mb-30" id="affix-container">
    <div class="animated fadeInUp card-base baslikBg">Talimat Güncelle</div>
    <el-row class="mt-10" :gutter="10" v-loading="loading || addLoading"
            :element-loading-text='loading ? "Yükleniyor" : addLoading ? "Veriler Ekleniyor. Lütfen Bekleyiniz." : ""'
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-form status-icon class="demo-ruleForm">
        <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft pb-20 pt-20">
          <el-row>
            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
              <el-form-item label="Şablon" prop="sablon">
                <el-select :disabled="true" style="padding-bottom: 0; width: 100%" size="small" v-model="selectTemplate"
                           placeholder="Şablon Seçiniz" filterable :filter-methos="filterMethod">
                  <el-option v-for="(item) in templates" :key="item.id" :label="item.sablonAdi"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft flex">
          <el-col :lg="6" :md="6" :sm="6" :xs="6" class="p-15" style="padding-top: 0;">
            <el-form-item v-if="matchedRows.includes(item.key)" class="mb-2" v-for="(item, index) in inputTypes"
                          :label="item.holder + ' Giriniz'"
                          :prop="item.key">
              <el-input clearable class="mb-6 ml-0" size="mini" :id="item.key" @input="handleOnChange"
                        @focus="(ev) => handleFocus(ev.target.id)" :disabled="!matchedRows.includes(item.key)"
                        :placeholder="item.holder" v-model="item.model"/>
            </el-form-item>
          </el-col>
          <el-col :lg="18" :md="18" :sm="18" :xs="18" class="p-20 pt-0 border-left">
            <div v-html="previewOnScreen"></div>
            <div v-if="selectTemplate == 1">
              <ckeditor :editor="editor" :config="editorConfig" v-model="personelList"></ckeditor>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="12" v-if="selectTemplate !== null"
                class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft p-20">
          <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
            <el-button :loading="isSave" @click="talimatOlustur" size="mini">Kaydet</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import CKeditor from '@ckeditor/ckeditor5-build-classic/build/ckeditor'
import talimatService from '../../../WSProvider/TalimatService';
import yoneticiService from '../../../WSProvider/YoneticiService';
import WrittenNumber from 'written-number'
import notification from "@/notification";
import EventBus from "@/components/event-bus";
import functions from "@/functions";

export default {
  name: "TalimatGuncelle",
  components: {},
  computed: {
    getTalimatData() {
      return this.$store.getters.getTalimatData
    },
  },
  data() {
    return {
      isSave: false,
      file: [],
      imageListMain: [],
      addLoading: false,
      loading: false,
      editor: CKeditor,
      editorConfig: {
        language: 'tr',
      },
      matchedRows: [],
      selectTemplate: null,
      personelList: '',
      templates: [],
      originalPreview: '',
      previewOnScreen: null,
      tarih: '',
      sayi: '',
      konu: '',
      banka: '',
      alici: '',
      inputTypes: [
        {
          holder: 'Hesap No',
          model: '',
          key: 'hesapNo'
        },
        {
          holder: 'Tahakkuk',
          model: '',
          key: 'tahakkuk'
        },
        {
          holder: 'İban',
          model: '',
          key: 'iban'
        },
        {
          holder: 'Yil',
          model: '',
          key: 'yil'
        },
        {
          holder: 'Ay',
          model: '',
          key: 'ay'
        },
        {
          holder: 'Tutar',
          model: '',
          key: 'tutar'
        },
        {
          holder: 'Fiyat',
          model: '',
          key: 'fiyat'
        },
        {
          holder: 'İsim',
          model: '',
          key: 'isimSoyisim'
        },
        {
          holder: 'TL',
          model: '',
          key: 'tl'
        },
        {
          holder: 'KR',
          model: '',
          key: 'kr'
        },
        {
          holder: 'Banka',
          model: '',
          key: 'banka'
        },
        {
          holder: 'Alıcı',
          model: '',
          key: 'alici'
        },
        {
          holder: 'Tutar',
          model: '',
          key: 'tutar'
        },
        {
          holder: 'Açıklama',
          model: '',
          key: 'aciklama'
        },
      ]
    }
  },
  created() {
    if (this.getTalimatData) {
      Object.entries(this.getTalimatData).forEach(veri => {
        const [key, value] = veri
        this.inputTypes.forEach(item => {
          if (key == item.key) {
            item.model = value
          }
        })
      })
      this.originalPreview = this.getTalimatData.sablon_icerik
      // console.log('data', this.getTalimatData)
      // console.log('original', this.originalPreview)
      this.handleOnChange()
      // this.previewOnScreen = this.handleHtmlEdit(this.originalPreview, this.inputTypes)
    }
  },
  async mounted() {
    try {
      this.loading = true
      // this.previewOnScreen = this.handleHtmlEdit(this.originalPreview, this.inputTypes)
      let templates = await talimatService.getTemplates()
      this.selectTemplate = templates.data.find(item => item.sablonAdi === this.getTalimatData.sablonAdi)
      this.templates = templates.data
      this.loading = false
    } catch (error) {
      this.loading = false
      console.log(error);
    }
  },
  watch: {
    previewOnScreen(newVal) {
      // console.log('change', newVal)
    },
    async selectTemplate(id) {
      return false
      try {
        // this.originalPreview = this.templates.find(x => x.id === id).icerik || ''
        this.matchedRows = this.originalPreview.match(/{{(.*?)}}/g).map(x => x.replace('{{', '').replace('}}', ''))
        this.inputTypes = this.inputTypes.map(x => ({...x, model: ''}))
        this.previewOnScreen = this.handleHtmlEdit(this.originalPreview, this.inputTypes)
        // 1. duruma özel olarak ckeditör içerisine firma personellerini listeler
        if (id == 1) {
          // tüm kullanıcıları filtrelemeden getiren servis yazılmalı
          this.loading = true;
          let response = await yoneticiService.yoneticiListe(1, 0, 10000)
          let figure = document.createElement('figure')
          figure.classList.add('table')
          let table = document.createElement('table')
          let tableBody = document.createElement('tbody')
          let tableHead = document.createElement('thead')
          let th1 = document.createElement('th')
          let th2 = document.createElement('th')
          let th3 = document.createElement('th')
          let th4 = document.createElement('th')
          th1.textContent = 'Adı Soyadı'
          th2.textContent = 'Iban / Hesap No'
          th3.textContent = 'Açıklama'
          th4.textContent = 'Tutar'
          tableHead.append(th1)
          tableHead.append(th2)
          tableHead.append(th3)
          tableHead.append(th4)
          table.append(tableHead)
          response.data.forEach(user => {
            let tr = document.createElement('tr')
            let isimSoyisim = document.createElement('td')
            isimSoyisim.textContent = user.yoneticiAdi
            let iban = document.createElement('td')
            iban.textContent = user.iban || 'İban bulunamadı'
            let aciklama = document.createElement('td')
            aciklama.textContent = new Date().getFullYear() + '/' + new Date().getMonth() + ' Maaş'
            let tutar = document.createElement('td')
            tutar.textContent = user.maas
            tr.append(isimSoyisim)
            tr.append(iban)
            tr.append(aciklama)
            tr.append(tutar)
            tableBody.append(tr)
          })
          table.append(tableBody)
          figure.append(table)
          this.personelList = figure.outerHTML
          this.loading = false;
        } else if (id === 2) {
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // inputTypes: {
    //   handler: function (val) {
    //     if (val) val[4].model = WrittenNumber(val[3].model, {lang: 'tr'})
    //   },
    //   deep: true
    // }
  },
  methods: {
    imageUpload(file) {
      this.imageListMain = []
      if ((file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png')) {
        this.imageListMain.push(file.raw)
      }
    },
    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) >= 0;
    },
    handleFocus(id) {
      let elements = document.getElementsByClassName('defaultText')
      for (let index = 0; index < elements.length; index++) {
        const el = elements[index];
        if (el.className.includes(id))
          el.classList.add('editing')
        else
          el.classList.remove('editing')
      }
    },
    handleOnChange() {
      let html = this.originalPreview
      // console.log('original', html)
      this.inputTypes.forEach(item => {
        // console.log('item', item)
        // html = html.replaceAll(`{{${item.key}}}`, `<b>${item.model}</b>`)
        if (item.model !== '' && item.model != null) {
          // console.log('key', item.key)
          // console.log('model', item.model)
          // console.log('holder', item.holder)
          // html = html.replaceAll(`<b>10000</b>`, `<b>{{${item.holder}}</b>`)
          html = html.replaceAll(`{{${item.key}}}`, `<code class="defaultText ${item.key}"><b>${item.model}</b></code>`)
        } else {
          // let _item = ` <code class="defaultText ${item.key}"><b>${item.holder}</b></code>`
          // html = html.replaceAll(`{{${item.key}}}`, _item)
        }

        // if (item.model !== '') {
        //   html = html.replaceAll(`{{${item.key}}}`, `<b>${item.model}</b>`)
        // } else {
        //   let _item = ` <code class="defaultText ${item.key}"><b>${item.holder}</b></code>`
        //   html = html.replaceAll(`{{${item.key}}}`, _item)
        // }
      })
      // this.inputTypes.forEach(item => {
      //   if (item.model !== '') {
      //     html = html.replaceAll(`{{${item.key}}}`, `<b>${item.model}</b>`)
      //   } else {
      //     let _item = ` <code class="defaultText ${item.key}"><b>${item.holder}</b></code>`
      //     html = html.replaceAll(`{{${item.key}}}`, _item)
      //   }
      // })
      /////////////////////////
      // this.inputTypes.forEach(item => {
      //   if (item.model !== '') {
      //     let _item = ` <code class="defaultText ${item.key}"><b>${item.holder}</b></code>`
      //     html = html.replaceAll(`{{${item.key}}}`, _item)
      //   } else {
      //     html = html.replaceAll(`{{${item.key}}}`, `<b>${item.model}</b>`)
      //   }
      // })
      // this.matchedRows = html.match(/{{(.*?)}}/g).map(x => x.replace('{{', '').replace('}}', ''))
      this.previewOnScreen = html
      // console.log('previewOnScreen', this.previewOnScreen)
    },
    handleHtmlEdit(html, keys) {
      let newHtml = html
      keys.forEach(item => {
        let _item = ` <code class="defaultText ${item.key}"><b>${item.holder}</b></code>`
        newHtml = newHtml.replaceAll(`{{${item.key}}}`, _item)
      });

      return newHtml
    },
    talimatOlustur() {
      this.isSave = true
      const sablonAdi = this.templates.find(item => item.id == this.selectTemplate).sablonAdi
      if (this.selectTemplate == 1) {
        let figure = document.createElement('figure')
        talimatService.talimatEkle(this.sayi, this.tarih, this.konu, this.banka, this.alici, 'iban', 'tutar', 'aciklama', 'sablon', this.personelList)
            .finally(() => {
              this.isSave = true
            })
      } else {
        talimatService.talimatEkle(sablonAdi, this.inputTypes, this.previewOnScreen).then((response) => {
          if (response.status == 200) {
            notification.Status('success', this, response.msg);
            EventBus.$emit("talimatListesi", true)
            functions.sayfaKapat("talimattanimla", this);
            functions.routeSayfa("Talimat Listesi", this)
          }
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
            } else notification.Status("errorMsg", this, error.errMsg)
          }
          this.loading = false;
        }).finally(() => {
          this.isSave = true
        })
      }
    }
  }
}

</script>
<style>
.defaultText {
  /* background-color: black;
  border-radius: 4px;
  padding: 2px;
  box-shadow: 0px 0px 2px 0px #000000c7;
  color: white; */
  border: 1px solid black;
  border-radius: 6px;
  padding-inline: 6px;
}

.editing {
  border: 2px solid blue;
}
</style>